

























import { defineComponent } from '@vue/composition-api';
import { PropType } from 'vue';

const name = 'ttam-operation-list';

export default defineComponent({
  name,
  props: {
    list: {
      type: Array as PropType<
        {
          icon: string;
          hint?: string;
          placement: string;
          disabled?: boolean;
          loading?: boolean;
          type?: string;
          trackProps?: Record<string, string>;
          click: () => void;
        }[]
      >,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const onClick = (fn: () => void) => {
      fn();
      emit('click');
    };
    return {
      name,
      onClick,
    };
  },
});
